// contracts
export const contractsConfig = {
  text_filter: '',
  customer: 'all',
  manager: 'all',
  field_manager: 'all',
  status: 'all',
  sortMode: 'asc',
  sortBy: 'date'
}

export const getContractsUrl = (path, filters) => {
  const { company, contracts } = filters
  const {
    text_filter,
    customer,
    manager,
    field_manager,
    status,
    sortMode,
    sortBy
  } = contracts

  return `
    ${path}?
    text_filter=${text_filter.replace(/ /g, '%20')}&
    company=${company}&
    customer=${customer}&
    manager=${manager}&
    field_managers=${field_manager}&
    status=${status}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// amendments
export const amendmentsConfig = {
  status: 'all',
  sortMode: 'asc',
  sortBy: 'date'
}

export const getAmendmentsUrl = (path, filters) => {
  const { status, sortMode, sortBy } = filters

  return `
    ${path}&
    status=${status}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// contragents
export const contragentsConfig = {
  status: 'all',
  sortMode: 'asc',
  sortBy: 'name'
}

export const getContragentsUrl = (path, filters) => {
  const { status, sortMode, sortBy } = filters

  return `
    ${path}&
    status=${status}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// acts
export const actsConfig = {
  status: 'all',
  sortMode: 'asc',
  sortBy: 'send_date',
  viewMode: 'list'
}

export const getActsUrl = (path, filters) => {
  const { status, sortMode, sortBy } = filters

  return `
    ${path}
    status=${status}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// payments
export const paymentsConfig = {
  sortMode: 'asc',
  sortBy: 'date'
}

export const getPaymentsUrl = (path, filters) => {
  const { sortMode, sortBy } = filters

  return `
    ${path}
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// law-cases
export const lawCasesConfig = {
  from_company: 'all',
  status: 'all',
  sortMode: 'asc',
  sortBy: 'costs'
}

export const getLawCasesUrl = (path, filters) => {
  const { from_company, status, sortMode, sortBy } = filters

  return `
    ${path}&
    from_company=${from_company}&
    status=${status}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// procedures
export const proceduresConfig = {
  type: 'all',
  status: 'all',
  sortMode: 'asc',
  sortBy: 'date'
}

export const getProceduresUrl = (path, filters) => {
  const { type, status, sortMode, sortBy } = filters

  return `
    ${path}&
    type=${type}&
    status=${status}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// resources
export const resourcesConfig = {
  object_type: 'all',
  sortMode: 'asc',
  sortBy: 'created_at'
}

export const getResourcesUrl = (path, filters) => {
  // const { object_type, sortMode, sortBy } = filters

  // return `
  //   ${path}&
  //   object_type=${object_type}&
  //   order=${sortBy}_${sortMode}
  // `.replace(/ /g, '')

  return `${path}&order=created_at_asc`
}

// experience
export const experienceFilters = [
  {
    name: 'status',
    label: 'Статус'
  },
  {
    name: 'customer_name',
    label: 'Заказчик'
  },
  {
    name: 'customer_group_name',
    label: 'Группа компаний'
  },
  {
    name: 'planer_type',
    label: 'Тип проектировщика'
  },
  {
    name: 'project_stage_name',
    label: 'Стадия проектирования'
  },
  {
    name: 'contract_start_year',
    label: 'Год начала'
  },
  {
    name: 'contract_end_year',
    label: 'Год окончания'
  },
  {
    name: 'costs',
    label: 'Сумма (по договору)'
  },
  {
    name: 'signed_act_costs',
    label: 'Сумма (по актам)'
  },
  {
    name: 'payments_value',
    label: 'Сумма (по оплатам)'
  },
  {
    name: 'contragent_costs',
    label: 'Сумма подряда'
  },
  {
    name: 'object_type_name',
    label: 'Тип объекта'
  },
  {
    name: 'federal_district_name',
    label: 'Федеральный округ'
  },
  {
    name: 'profile_work_region_name',
    label: 'Регион (проф.)'
  },
  {
    name: 'territory_types',
    label: 'Тип территории'
  },
  {
    name: 'climate_condition_name',
    label: 'Климатические условия'
  },
  {
    name: 'job_types',
    label: 'Виды работ'
  },
  {
    name: 'responsibility_level_name',
    label: 'Уровень ответственности'
  },
  {
    name: 'review_exists',
    label: 'Отзыв'
  },
  {
    name: 'expert_exists',
    label: 'Экспертиза'
  },
  {
    name: 'tender_type_name',
    label: 'Тип тендера'
  },
  {
    name: 'special_tech_conditions',
    label: 'СТУ'
  }
]
export const experienceConfig = {
  customer_name: [],
  customer_group_name: [],
  planer_type: [],
  status: [],
  object_type_name: [],
  job_types: [],
  territory_types: [],
  project_stage_name: [],
  federal_district_name: [],
  profile_work_region_name: [],
  climate_condition_name: [],
  responsibility_level_name: [],
  contract_start_year: [],
  contract_end_year: [],
  costs: 0,
  signed_act_costs: 0,
  payments_value: 0,
  contragent_costs: 0,
  review_exists: [],
  expert_exists: [],
  tender_type_name: [],
  special_tech_conditions: [],
  sortMode: 'asc',
  sortBy: 'code'
}

export const getExperienceUrl = (path, filters) => {
  const { company, experience } = filters
  const {
    customer_name,
    customer_group_name,
    planer_type,
    status,
    object_type_name,
    job_types,
    territory_types,
    project_stage_name,
    federal_district_name,
    profile_work_region_name,
    climate_condition_name,
    responsibility_level_name,
    contract_start_year,
    contract_end_year,
    review_exists,
    expert_exists,
    tender_type_name,
    special_tech_conditions,
    costs,
    signed_act_costs,
    payments_value,
    contragent_costs,
    sortMode,
    sortBy
  } = experience

  let query = `${path}company=${company}&customer_name=${customer_name.join(
    ','
  ) || 'all'}&customer_group_name=${customer_group_name.join(',') ||
    'all'}&planer_type=${planer_type.join(',') || 'all'}&status=${status.join(
    ','
  )}&job_types=${job_types.join(',') ||
    'all'}&object_type_name=${object_type_name.join(',') ||
    'all'}&territory_types=${territory_types.join(',') ||
    'all'}&project_stage_name=${project_stage_name.join(',') ||
    'all'}&federal_district_name=${federal_district_name.join(',') ||
    'all'}&profile_work_region_name=${profile_work_region_name.join(',') ||
    'all'}&climate_condition_name=${climate_condition_name.join(',') ||
    'all'}&responsibility_level_name=${responsibility_level_name.join(',') ||
    'all'}&contract_start_year=${contract_start_year.join(',') ||
    'all'}&contract_end_year=${contract_end_year.join(',') ||
    'all'}&special_tech_conditions=${special_tech_conditions.join(',') ||
    'all'}&tender_type_name=${tender_type_name.join(',') ||
    'all'}&review_exists=${review_exists.join(',') ||
    'all'}&expert_exists=${expert_exists.join(',') || 'all'}`

  if (costs) query += `&costs=>${costs}`
  if (signed_act_costs) query += `&signed_act_costs=>${signed_act_costs}`
  if (payments_value) query += `&payments_value=>${payments_value}`
  if (contragent_costs) query += `&contragent_costs=>${contragent_costs}`

  return `${query}&order=${sortBy}_${sortMode}`.replace(/\n/g, '')
}

// time-table
export const timeTableConfig = {
  text_filter: '',
  customer: 'all',
  status: 'all',
  manager: 'all',
  sortMode: 'asc',
  sortBy: 'date'
}

export const getTimeTableUrl = (path, filters) => {
  const { company, timeTable } = filters
  const {
    text_filter,
    customer,
    status,
    manager,
    sortMode,
    sortBy
  } = timeTable

  return `
    ${path}?
    text_filter=${text_filter.replace(/ /g, '%20')}&
    company=${company}&
    customer=${customer}&
    status=${status}&
    manager=${manager}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}

// contract registry
export const contractsRegisterConfig = {
  text_filter: '',
  customer: 'all',
  status: 'all',
  sortMode: 'asc',
  sortBy: 'code'
}

export const getContractsRegisterUrl = (path, filters) => {
  const { company, contractsRegister } = filters
  const { text_filter, customer, status, sortMode, sortBy } = contractsRegister

  return `
    ${path}?
    text_filter=${text_filter.replace(/ /g, '%20')}&
    company=${company}&
    customer=${customer}&
    status=${status}&
    order=${sortBy}_${sortMode}
  `.replace(/ /g, '')
}
